export interface AffiliateOffer {
  id: string;
  label: string;
  labelEn: string;
  url: string;
  icon: 'wifi' | 'smartphone' | 'cable' | 'router' | 'creditcard' | 'zap';
  tag: string;
  tagEn: string;
  url2?: string;
  label2?: string;
  label2En?: string;
  image?: string;
}

export interface AffiliateProgram {
  id: string;
  name: string;
  /** Tailwind gradient classes for the card header */
  gradient: string;
  /** Solid brand color (hex) for accents */
  brandColor: string;
  /** Light brand background */
  brandBgLight: string;
  /** Brand border color */
  brandBorder: string;
  offers: AffiliateOffer[];
}

export const affiliatePrograms: AffiliateProgram[] = [
  {
    id: 'o2',
    name: 'O₂',
    gradient: 'from-[#006B99] via-[#0078A8] to-[#0099CC]',
    brandColor: '#006B99',
    brandBgLight: '#E6F4F9',
    brandBorder: '#B3D9E8',
    offers: [
      {
        id: 'o2-internet',
        label: 'DSL & Kabel Tarife jetzt entdecken',
        labelEn: 'Discover DSL & cable plans now',
        url: 'https://www.communicationads.net/tc.php?t=18676C16024358T',
        icon: 'wifi',
        tag: 'Internet zuhause',
        tagEn: 'Home internet',
        image: '/ChatGPT_Image_1._Aug._2026,_03_10_42 copy.png',
      },
      {
        id: 'o2-mobilfunk',
        label: 'Wähle die passenden Handytarife aus',
        labelEn: 'Choose the right mobile plans',
        url: 'https://www.communicationads.net/tc.php?t=18676C16027643T',
        icon: 'creditcard',
        tag: 'Mobilfunk',
        tagEn: 'Mobile',
        image: '/ChatGPT_Image_1._Aug._2026,_03_10_32 copy.png',
      },
    ],
  },
  {
    id: 'vodafone',
    name: 'Vodafone',
    gradient: 'from-[#E60000] via-[#D50000] to-[#CC0000]',
    brandColor: '#E60000',
    brandBgLight: '#FDEAEA',
    brandBorder: '#F5B8B8',
    offers: [
      {
        id: 'vodafone-kabel',
        label: 'Kabel-Internet jetzt entdecken',
        labelEn: 'Discover cable internet now',
        url: 'https://www.communicationads.net/tc.php?t=18676C14623072T',
        icon: 'cable',
        tag: 'Kabel',
        tagEn: 'Cable',
        image: '/Bildschirmfoto_2026-08-01_um_02.57.10.png',
      },
      {
        id: 'vodafone-dsl',
        label: 'DSL-Tarife jetzt vergleichen',
        labelEn: 'Compare DSL plans now',
        url: 'https://www.communicationads.net/tc.php?t=18676C14624733T',
        icon: 'router',
        tag: 'DSL',
        tagEn: 'DSL',
        image: '/Bildschirmfoto_2026-08-01_um_02.57.39.png',
      },
      {
        id: 'vodafone-mobilfunk',
        label: 'Mobilfunk-Tarife auswählen',
        labelEn: 'Choose mobile plans',
        url: 'https://www.communicationads.net/tc.php?t=18676C14624727T',
        icon: 'smartphone',
        tag: 'Mobilfunk',
        tagEn: 'Mobile',
        image: '/Bildschirmfoto_2026-08-01_um_02.58.00.png',
      },
    ],
  },
  {
    id: '1und1',
    name: '1&1',
    gradient: 'from-[#006DB3] via-[#0060A0] to-[#005490]',
    brandColor: '#006DB3',
    brandBgLight: '#E6F2FA',
    brandBorder: '#B3D6EE',
    offers: [
      {
        id: '1und1-dsl',
        label: 'DSL & Glasfaser Tarife jetzt sichern',
        labelEn: 'Get DSL & fibre plans now',
        url: 'https://dsl.1und1.de/?ps_id=P314888338',
        icon: 'wifi',
        tag: 'DSL & Glasfaser',
        tagEn: 'DSL & Fibre',
        image: '/DSL Tarife/Bildschirmfoto_2026-07-30_um_04.03.35 copy copy copy.png',
      },
      {
        id: '1und1-mobile',
        label: 'Handy mit Vertrag – Angebote entdecken',
        labelEn: 'Discover smartphone with contract offers',
        url: 'https://mobile.1und1.de/smartphones?ps_id=P314888338#angebot',
        icon: 'smartphone',
        tag: 'Handy mit Vertrag',
        tagEn: 'Phone with contract',
        image: '/Smartphones/Bildschirmfoto_2026-07-30_um_04.03.09 copy copy copy copy.png',
      },
    ],
  },
  {
    id: 'blau',
    name: 'blau',
    gradient: 'from-[#00A0E0] via-[#0099D4] to-[#0088C0]',
    brandColor: '#00A0E0',
    brandBgLight: '#E6F6FD',
    brandBorder: '#B3E2F4',
    offers: [
      {
        id: 'blau-start',
        label: 'Zur Blau Startseite',
        labelEn: 'Go to Blau homepage',
        url: 'https://www.communicationads.net/tc.php?t=18676C15224084T',
        icon: 'zap',
        tag: 'Startseite',
        tagEn: 'Homepage',
        image: '/Zur Blau Startseite/ChatGPT_Image_1._Aug._2026,_01_36_33.png',
      },
      {
        id: 'blau-top',
        label: 'Top Angebote sichern',
        labelEn: 'Grab top deals',
        url: 'https://www.communicationads.net/tc.php?t=18676C15225080T',
        icon: 'smartphone',
        tag: 'Top Angebote',
        tagEn: 'Top deals',
        image: '/Top Angebote/Bildschirmfoto_2026-08-01_um_01.34.54 copy.png',
      },
    ],
  },
];
